import React from 'react';
import classnames from 'classnames';
import flow from 'lodash/flow';
import { translate } from 'react-i18next';

import SubcompaniesSchemas from 'schemas/subcompanies.schemas';
import validated from 'components/util/Validated';
import { Form } from 'common/components';

const SubcompanyForm = ({
  companyId = null,
  errors = {},
  isLoading = false,
  isSubmitted = false,
  handleSubmit = () => {},
  handleValueChange = () => {},
  t = (k) => k,
  values = {},
}) => {
  // console.clear();
  // console.table(values);
  return (
    <form onSubmit={handleSubmit} noValidate autoComplete="false">
      <div className="row mt-3 align-items-center">
        <div className="col-sm-6 col-md-4">
          <Form.FieldInput
            autoFocus={true}
            error={(isSubmitted && errors.shortname) || {}}
            name={'shortname'}
            label={t('subcompanies.fields.shortname')}
            placeholder={t('subcompanies.fields.shortname')}
            handleChange={handleValueChange}
            t={t}
            value={values.shortname}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <Form.FieldInput
            error={(isSubmitted && errors.name) || {}}
            name={'name'}
            label={t('subcompanies.fields.name')}
            placeholder={t('subcompanies.fields.name')}
            handleChange={handleValueChange}
            t={t}
            value={values.name}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <Form.Checkbox
            name="active"
            className="icheckbox_flat-blue"
            onChange={handleValueChange}
            checked={values.active}
            label={t('common.active', { context: 'female' })}
          />
        </div>

        {/* Modulo Extra de Mantenimiento */}
        {/* <div className="col-sm-6 col-md-4">
          <Form.Checkbox
            name="maintenance"
            className="icheckbox_flat-blue"
            onChange={handleValueChange}
            checked={values.maintenance}
            label={t("mantenimiento_module.title", { context: "female" })} // Titulo
          />
        </div> */}
        <div className="col-md-12">
          <Form.Button
            text={t('actions.save')}
            isLoading={isLoading}
            extraClassName={'pull-right btn-xs-block'}
          />

          <Form.Link
            to={`/companies/${companyId}`}
            className={classnames('btn btn-secondary pull-right mr-3', {
              disabled: isLoading,
            })}
          >
            {t('actions.cancel')}
          </Form.Link>
          <div className="clearfix" />
        </div>
      </div>
    </form>
  );
};

export default flow(translate(), validated(SubcompaniesSchemas.edit))(SubcompanyForm);



// WEBPACK FOOTER //
// src/modules/secured/modules/subcompanies/components/SubcompanyForm.js